import React from 'react';
import withRouter from '../withRouter';

const LoginWrapper: React.FC<{ className?: string }> = (props) => {
	return (
		<div className={`gray-bg login-wrapper ${props.className || ''}`}>
			<div className="middle-box loginscreen animated fadeInDown">
				<div>
					<br />
					{props.children}
				</div>
			</div>
		</div>
	);
};

export default withRouter(LoginWrapper);
